module.exports = __webpack_public_path__ + "static/media/phaneroptera_nana.9171b3ab.jpg";